import api from 'services/api';

export async function getOrganization(id: string) {
  const response = await api.get(`api/dashboard/organizations/${id}`);
  return response;
}
